import LinkButton from '@/shared/components/UI/LinkButton';

const CartEmpty = () => {
  return (
    <section className="mx-auto my-[80px] flex min-h-[18rem] w-[30rem] flex-col items-center justify-center text-center">
      <h3 className="mb-9 text-[24px] font-extrabold tracking-wider text-[#95699f]">
        CART
      </h3>
      <p className="text-[18px] font-semibold tracking-wider text-[#444]">
        Your cart is empty
      </p>
      <LinkButton
        to="/"
        variant="primary"
        className="mt-5 h-11 w-[320px] px-6 text-[18px]"
      >
        Continue Shopping
      </LinkButton>
    </section>
  );
};

export default CartEmpty;
